import React from "react";
import { Col, Container, Row } from "reactstrap";
import logo from "../../../assets/images/logos/moore-logo-black.png";
import AlliottLogo from "../../../assets/images/alliott-logo.jpg";

import "./style.scss";

import { renderRowHTML } from "../../../utils/utils";
const MyPDFContent = (props: any) => {
  const unescape = (s: string) => {
    return s
      .replace(/&amp;/g, "&")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&#39;/g, "'")
      .replace(/&quot;/g, '"');
  };
  return (
    <Container>
      <div className="pdfContainer">
        {props.content.map((content: any, index: any) => (
          <div className="pdfPage">
            <Header />
            <div className="pdfBody">
              <Row>
                <Col>{content ? renderRowHTML(unescape(content), "") : ""}</Col>
              </Row>
            </div>
            <Footer />
          </div>
        ))}
      </div>
    </Container>
  );
};
const Header = () => {
  return (
    <Row>
      <Col>
        <img src={logo} alt="logo" width="120px" />
      </Col>
      <Col>
        <h1 style={{ color: "#c8222a", fontSize: "28px", textAlign: "right" }}>MOORE BV / SRL</h1>
      </Col>
    </Row>
  );
};

const Footer = () => {
  return (
    <Row className="invoiceFooter">
      <Col className="col-12 strong">
        <p>MOORE BV / SRL</p>
      </Col>
      <Col className="col-9">
        <p>
          Esplanade 1, Bus 96, Buro & Design Center
          <br />
          1020 Laken (Brussels), Belgium
        </p>
      </Col>
      <Col className="col-3 tel-no">Tel. +32 2 675 50 05</Col>
      <Col className="col-9">
        <p>T.V.A/B.T.W. BE 0740.763.660</p>
      </Col>
      <Col className="col-3"></Col>
    </Row>
  );
};

export default MyPDFContent;
